import React from 'react';
import { NeoReport, Report } from "@singularsystems/neo-reporting";
import { MaintenanceReportCategories } from "../MaintenanceReportCategories";
import { Layout } from '@singularsystems/neo-canvas-grid';
import InstrumentsWithNumericDisplayNamesReportCriteria from "./InstrumentsWithNumericDisplayNamesReportCriteria";

@NeoReport("InstrumentsWithNumericDisplayNames", { category: MaintenanceReportCategories.DataEnrichmentReports })
export default class InstrumentsWithNumericDisplayNamesReport extends Report<InstrumentsWithNumericDisplayNamesReportCriteria> {
    
    constructor() {
        super(InstrumentsWithNumericDisplayNamesReportCriteria);
    }

    public renderCriteria() {
        return (
        <>
        </>);
    }

    public getDefaultGridLayout() {
        return {
            "root": {
            }
        } as Layout.IGridLayout;
    }
}